<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <img class="header-bg" src="../assets/img/banner9.jpg" alt="" />
      <div class="navi-container">
        <div class="navi-list">
          <div class="navi-item active">
            <a href="gywm_u.html">关于我们</a>
          </div>
          <div class="navi-item">
            <a href="zshz_u.html">招商合作</a>
          </div>
          <div class="navi-item">
            <a href="zxns_u.html">招贤纳士</a>
          </div>
          <div class="navi-item dio">
            <a href="xswd_u.html">销售网点</a>
          </div>
          <div class="navi-item">
            <a href="zxly_u.html">在线留言</a>
          </div>
        </div>
      </div>

      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <div class="title">公司简介</div>
            <div class="bar"></div>
            <div class="desc">
              河南农极客农业科技有限公司，是行业内知名的自媒体平台每天农资孵化出的一家创新实战性的农业科技公司。早在成立之前，公司就一直专注在改土生根领域的研究，旨在为广大农业服务人员提供优质高效的改土生根产品，帮助作物从根本上解决问题。<br /><br />

              目前公司针对改良土壤，促进作物生根，预防病虫害等问题研发了多款创新配方，涵盖叶面肥、水溶肥、微生物菌剂等全系列产品，深受众多经销商的一致好评。
其中，海藻酸叶面肥（普罗迈斯）、含氨基酸水溶肥料（小小根生根肥、大壮猫鱼蛋白氨基酸水溶肥）、含腐植酸水溶肥料（台红二代、腐植酸叶面肥）、微生物菌剂（农拾五亿菌剂、金农拾五亿菌剂、农拾20亿菌剂）等产品深受广大种植户的青睐。<br /><br />

              未来，公司本着“让农资用对，用好”的信念，将以更多优质的产品，更切合农业需要的目标立足农业，服务广大农业服务人员。
            </div>
          </div>
        </div>
      </div>
      <div class="articleList-container" style="background: #f5f5f5">
        <div class="articleList-content">
          <div class="articleList">
            <div class="title">公司文化</div>
            <div class="bar"></div>
            <div class="culture">
              <div class="culture-item">
                <img src="../assets/img/yuanjing.png" alt="" />
                <div class="culture-title">愿景</div>
                <div class="culture-desc">让农业变成高科技行业</div>
              </div>
              <div class="culture-item">
                <img src="../assets/img/shiming.png" alt="" />
                <div class="culture-title">使命</div>
                <div class="culture-desc">专注农资零售商经营升级服务</div>
              </div>
              <div class="culture-item">
                <img src="../assets/img/jiazhiguan.png" alt="" />
                <div class="culture-title">价值观</div>
                <div class="culture-desc">负责 诚信 主动 不怕认错</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <div class="title">发展历程</div>
            <div class="bar"></div>
            <div class="history dio">
              <div class="col-bar"></div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2021</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客共同体年中会议<br /><br />
                  农极客药搭配、农极客硼钼液、农极客钙镁硼等新产品上架
                </div>
              </div>
              <div class="year-item lt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2020</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客共同体年中会议<br /><br />
                  第五届野蛮生长会议——突围
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2019</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客332计划启动（农极客共同体）样板市场+经验复制
                  真正开始从线上转到线下零售服务
                  <br /><br />第四届野蛮生长会议——进击·种植服务商
                </div>
              </div>
              <div class="year-item lt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2018</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  喜开单发布 农资经营管理软件 助力农资门店经营分析，客户管理
                  喷一喷套餐袋 教会大田零售商套餐配药
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2017</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  野蛮生长会议 线下会议，零售行业风向标，开始系统的零售经营服务
                </div>
              </div>
              <div class="year-item lt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2016</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客APP上线 ，让农资用对用好，APP产品社区为产品赋能
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2015</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  产品众筹：磷酸二氢钾 缩短行业流通渠道 涉足农资团购众筹
                </div>
              </div>
              <div class="year-item lt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2014</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">郑州木加林文化传播有限公司注册</div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2013</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  每天农资微信公众平台开始运营 农资行业自媒体意见领袖
                  ：树立个人IP：老猫
                </div>
              </div>
            </div>
            <div class="history jojo">
              <div class="col-bar"></div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2021</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客共同体年中会议<br /><br />
                  农极客药搭配、农极客硼钼液、农极客钙镁硼等新产品上架
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2020</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客共同体年中会议<br /><br />
                  第五届野蛮生长会议——突围
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2019</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客332计划启动（农极客共同体）样板市场+经验复制
                  真正开始从线上转到线下零售服务
                  <br /><br />第四届野蛮生长会议——进击·种植服务商
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2018</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  喜开单发布 农资经营管理软件 助力农资门店经营分析，客户管理
                  喷一喷套餐袋 教会大田零售商套餐配药
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2017</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  野蛮生长会议 线下会议，零售行业风向标，开始系统的零售经营服务
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2016</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  农极客APP上线 ，让农资用对用好，APP产品社区为产品赋能
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2015</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  产品众筹：磷酸二氢钾 缩短行业流通渠道 涉足农资团购众筹
                </div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2014</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">郑州木加林文化传播有限公司注册</div>
              </div>
              <div class="year-item rt">
                <div class="year-i">
                  <div class="circle-l circle"></div>
                  <div class="line-l line"></div>
                  <div class="y">2013</div>
                  <div class="line-r line"></div>
                  <div class="circle-r circle"></div>
                </div>
                <div class="year-box">
                  每天农资微信公众平台开始运营 农资行业自媒体意见领袖
                  ：树立个人IP：老猫
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <div class="title">联系我们</div>
            <div class="bar" style="margin-bottom: 40px"></div>
            <div class="map-container">
              <baidu-map id="allmap" @ready="mapReady"> </baidu-map>

              <div class="com-info">
                <div class="com-item">
                  <div class="com-title">公司名称：</div>
                  <div class="com-desc">河南农极客农业科技有限公司</div>
                </div>
                <div class="com-item">
                  <div class="com-title">联系电话：</div>
                  <div class="com-desc"><a href="tel:400-800-8084">400-800-8084</a></div>
                </div>
                <div class="com-item">
                  <div class="com-title">公司邮箱：</div>
                  <div class="com-desc"><a href="mailto:nongjike1688@163.com" target="_blank">nongjike1688@163.com</a></div>
                </div>
                <div class="com-item">
                  <div class="com-title">网站联系人：</div>
                  <div class="com-desc"><a href="tel:19337130384">19337130384</a></div>
                </div>
                <div class="com-item">
                  <div class="com-title">公司地址：</div>
                  <div class="com-desc">
                    <a href="http://api.map.baidu.com/marker?location=34.799038,113.698653&title=河南省郑州市金水区金成国际广场B座1905室&content=&output=html" target="_blank">河南省郑州市金水区金成国际广场B座1905室</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
// import Like from "../components/likeList.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    // Like,
  },
  data: () => {
    return {
      totalpage: 1,
      currentpage: 1,

      cardType: "0", //0 农技文章,1活动卡片
      cardList: [],
    };
  },
  beforeMount() {},
  methods: {
    mapReady({ BMap, map }) {
      // 选择一个经纬度作为中心点
      this.point = new BMap.Point(113.698653, 34.799038);
      var scaleCtrl = new BMap.ScaleControl(); // 添加比例尺控件
      map.addControl(scaleCtrl);
      var cityCtrl = new BMap.CityListControl(); // 添加城市列表控件
      map.addControl(cityCtrl);
      map.centerAndZoom(this.point, 17);
      map.enableScrollWheelZoom(true);

      var marker = new BMap.Marker(this.point); // 创建标注
      map.addOverlay(marker);
      var polyline = new BMap.Polyline(
        [
          new BMap.Point(113.697616, 34.800331),
          new BMap.Point(113.699125, 34.800331),
          new BMap.Point(113.699143, 34.798153),
          new BMap.Point(113.698083, 34.798093),
          new BMap.Point(113.698101, 34.798553),
          new BMap.Point(113.696951, 34.798538),
          new BMap.Point(113.696843, 34.800998),
          new BMap.Point(113.697759, 34.800865),
          new BMap.Point(113.697616, 34.800331),
        ],
        {
          strokeColor: "#6791E5",
          strokeWeight: 2,
          strokeOpacity: 1,
          strokeStyle: "dashed",
        }
      );
      map.addOverlay(polyline);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#allmap {
  height: 400px;
  width: 100%;
  margin: 0 auto;
}
.map-container {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 60px;
  padding: 20px;
  border: 1px solid #ddd;
  background: #fff;
  box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.1);
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}
.title {
  font-size: 32px;
  color: #333;
  text-align: center;
  padding: 0 0 6px 0;
  // font-family: "NSimSun";
  font-weight: bold;
  padding-top: 70px;
}
.bar {
  width: 80px;
  height: 4px;
  margin: -5px auto 15px;
  background: #65b825;
}
.desc {
  font-size: 16px;
  color: #333;
  text-align: justify;
  line-height: 25px;
  margin-bottom: 75px;
  margin-top: 25px;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}
.culture {
  display: flex;
  justify-content: space-between;
  padding-bottom: 80px;
  align-items: center;
  .culture-item {
    width: 30%;
    justify-content: flex-start;
    align-items: center;
    display: flex;
    flex-direction: column;
    img {
      width: 128px;
      height: 128px;
      display: block;
    }
    .culture-title {
      font-size: 20px;
      color: #333;
      margin: 20px 0;
      text-align: center;
    }
    .culture-desc {
      font-size: 16px;
      color: #666;
      text-align: center;
    }
  }
}
.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.crop-selector-container {
  width: 100%;
  background: #f5f5f5;
  padding: 40px 0 24px;
  .crop-selector {
    width: 1200px;
    margin: 0 auto;

    .crop-item {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      &:last-child {
        margin-bottom: 0;
      }
      .crop-group {
        font-size: 16px;
        width: 80px;
        color: #333;
        text-align: left;
        margin-right: 10px;
        line-height: 20px;
      }
      .crop-titles {
        color: #999;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        line-height: 24px;

        a {
          border: 1px solid #999;
          color: #999;
          display: block;
          font-size: 14px;
          width: 136px;
          height: 36px;
          padding: 0 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-right: 16px;
          text-align: center;
          line-height: 34px;
          margin-bottom: 16px;
          &:hover {
            color: #fff;
            border-color: #65b825;
            background: #65b825;
          }
          &:nth-of-type(8n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    .articleList {
      width: 100px;
      flex-grow: 1;
      //   margin-right: 54px;
    }

    .likeList {
      width: 360px;
    }
  }
}
.navi-container {
  width: 100%;
  height: 64px;
  background: #65b825;
  .navi-list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #65b825;
    .navi-item {
      width: 240px;
      flex-grow: 1;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 62px;
      position: relative;
      left: -1px;
      a {
        display: block;
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 22px;
        color: #fff;
        border-right: 2px solid #fff;
        text-align: center;
      }
      &:last-child a {
        border-color: transparent;
      }
      &:hover {
        background: #fff;
        margin-left: -2px;
        margin-right: 2px;
        a {
          color: #65b825;
          border-right: transparent;
        }
      }
      &.active {
        background: #fff;
        margin-left: -2px;
        margin-right: 2px;
        a {
          color: #65b825;
          border-right: transparent;
        }
      }
    }
  }
}
.history {
  width: 100%;
  height: auto;
  position: relative;
  min-height: 400px;
  margin-top: 30px;
}
.col-bar {
  width: 2px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-1px);
  background: #65b825;
  z-index: 1;
}
.year-item {
  width: 100%;
  display: flex;
  align-items: center;
  &.lt {
    justify-content: flex-start;
    flex-wrap: nowrap;
    .circle-r {
      opacity: 0;
    }
    .line-r {
      opacity: 0;
    }
  }
  &.rt {
    justify-content: flex-end;
    flex-wrap: nowrap;
    .circle-l {
      opacity: 0;
    }
    .line-l {
      opacity: 0;
    }
  }
  .year-box {
    width: 540px;
    padding: 40px;
    border-radius: 5px;
    background: #f5f5f5;
    font-size: 16px;
    color: #333;
    position: relative;
    z-index: 4;
    cursor: pointer;
    &:hover {
      background: #65b825;
      color: #fff;
    }
  }
  .year-i {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .circle {
      width: 16px;
      height: 16px;
      border: 2px solid #65b825;
      border-radius: 50%;
      background: #fff;
    }
    .line {
      width: 16px;
      height: 2px;
      background: #65b825;
    }
    .y {
      width: 72px;
      // height: 32px;
      border: 2px solid #65b825;
      line-height: 28px;
      color: #65b825;
      font-size: 20px;
      text-align: center;
      background: #fff;
      color: #65b825;
      border: 1px solid #65b825;
      border-radius: 32px;
    }
  }
}
.com-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  // padding-bottom: 40px;
  padding-left: 30px;
  .com-item {
    width: 80%;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .com-title {
    font-size: 16px;
    color: #333;
  }
  .com-desc {
    font-size: 16px;
    color: #333333;
    margin-top: 2px;
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
    padding-left: 10px;
  }
  .headers {
    width: 100%;
    padding-left: 10px;
  }
  #app {
    overflow: hidden;
  }
  #app .headers .header-nav {
    display: none;
  }
  .navi-container {
    height: 37px;
    .navi-list {
      width: 100%;
      .navi-item {
        height: 36px;
        a {
          font-size: 14px;
        }
      }
    }
  }
  .articleList-container .articleList-content {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    .articleList {
      margin-right: 0;
    }
    .shop-list {
      justify-content: space-around;
      .shop-item {
        width: 40vw;
        margin-right: 0;
        height: 40vw;
        .shop-image {
          width: 40vw;
          height: 40vw;
          .el-image {
            width: 40vw;
            height: 40vw;
          }
        }
        .shop-info {
          width: 40vw;
          height: 30px;
          .shop-title {
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 10px;
          }
          .shop-more {
            top: 12px;
            img {
              width: 10px;
              height: 6px;
            }
          }
        }
      }
    }
  }
  .title {
    font-size: 20px;
    padding-top: 30px;
  }
  .bar {
    height: 2px;
  }
  .desc {
    font-size: 14px;
    margin-bottom: 30px;
  }
  .culture {
    align-items: flex-start;
    padding-bottom: 30px;
  }
  .culture .culture-item {
    .culture-title{
      font-size: 16px;
    }
    .culture-desc{
      font-size: 14px;
    }
    img {
      width: 70px;
      height: 70px;
    }
  }
  .history{
    padding-left: 70px;
  }
  .col-bar{
    left: 20px
  }
  .year-item{
    padding: 10px 0;
    .year-box{
      font-size: 15px;
      padding: 20px
    }
  }
  .year-item .year-i{
    left: 20px;
    .y{
      font-size: 16px;
      line-height: 25px;
      width: 50px;
    }
  }
  .map-container{
    flex-direction: column;
  }
  .com-info{
    padding-top: 20px;
  }
}
</style>
